/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.7.9",
    versionName: "0.4.0-nightly.2026.7.9",
    versionChannel: "nightly",
    buildDate: "2026-07-09T00:31:27.493Z",
    commitHash: "f8ec690e0d931dca8c8128b2c1a0e1e884fff890",
};
